import { z } from 'zod';
import { accountReferenceSchema } from './account';
import { objectMapSchema } from './object_map';
import { amountSchema } from './units';

const accountBalancesSchema = <T extends z.ZodType>(periodSchema: T) =>
  z.object({
    closingBalance: amountSchema,
    openingBalance: amountSchema,
    periodChange: objectMapSchema(periodSchema, amountSchema),
    periodClosingBalance: objectMapSchema(periodSchema, amountSchema),
  });

const allAccountBalancesSchema = <T extends z.ZodType>(periodSchema: T) =>
  z.object({
    accountBalances: objectMapSchema(accountReferenceSchema, accountBalancesSchema(periodSchema)),
    periods: z.array(periodSchema),
  });

export { accountBalancesSchema, allAccountBalancesSchema };
